import { z } from 'zod';

export const reportColumnSchema = z.object({
  header: z.string().min(1, '헤더명을 입력하세요').max(64, '헤더명은 64자 이하입니다'),
  field: z.string().min(1, '필드명을 입력하세요'),
  order: z.number().int().min(0),
  widthRatio: z.number().min(0.1).max(10).default(1.0),
  align: z.enum(['LEFT', 'CENTER', 'RIGHT']).default('LEFT'),
  barcodeMode: z.enum(['QR_CODE', 'CODE_128']).nullable().default(null),
  barcodeSourceField: z.string().nullable().default(null),
  barcodeEc: z.enum(['L', 'M', 'Q', 'H']).default('M'),
});

export const reportFilterSchema = z.object({
  field: z.string().min(1, '필드명을 입력하세요'),
  op: z.string().min(1, '연산자를 입력하세요'),
  value: z.string().default(''),
});

export const reportDefinitionSchema = z.object({
  name: z
    .string()
    .min(1, '리포트 이름을 입력하세요')
    .max(120, '이름은 120자 이하입니다'),
  description: z.string().max(512, '설명은 512자 이하입니다').optional().default(''),
  dataSource: z.enum(['user', 'audit-log', 'static'], {
    errorMap: () => ({ message: '데이터 소스를 선택하세요' }),
  }),
  defaultFormat: z.enum(['EXCEL', 'PDF'], {
    errorMap: () => ({ message: '출력 포맷을 선택하세요' }),
  }),
  columns: z
    .array(reportColumnSchema)
    .min(1, '컬럼을 1개 이상 추가하세요'),
  filters: z.array(reportFilterSchema).optional().default([]),
  shared: z.boolean().default(false),
});

export type ReportDefinitionFormValues = z.infer<typeof reportDefinitionSchema>;
export type ReportColumnFormValues = z.infer<typeof reportColumnSchema>;
